import { API_ROUTE_ADMIN_EMPLOYEE_CONSENT_REPORT } from '@/resources/api-routes'
import { get } from '@/util/auth'

type OriginalEmployeeConsentReport = {
  employees: {
    id: number
    name: string
    employeeNo: string
    code: string
    department: string
    email: string
    hasApproved: boolean
    approvedDate: string | null
  }[]
}

const IS_NEW_BACKEND_API = true

export async function getConsentReports(consentId: number) {
  const reports = await get<OriginalEmployeeConsentReport>(
    API_ROUTE_ADMIN_EMPLOYEE_CONSENT_REPORT.replace(':consentId', String(consentId)),
    IS_NEW_BACKEND_API
  )

  return reports.employees
}
